export enum CONSULTATION_STATUSES {
  ACTIVATED = 'ACTIVATED',
  DELETED = 'DELETED',
  PENDING = 'PENDING',
}

export enum CONSULTATION_REQUEST_TYPES {
  DEMO = 'DEMO REQUEST',
  SALES = 'SALES REQUEST',
  GENERIC = 'GENERIC REQUEST',
}

export enum SERVICES_PAGES {
  ENTERPRISE_SOFTWARE_SOLUTION = 'ENTERPRISE-SOFTWARE-SOLUTIONS',
  WEBSITE_DESIGN_AND_DEVELOPMENT = 'WEBSITE-DESIGN-AND-DEVELOPMENT',
  MOBILE_APPLICATION_DEVELOPMENT = 'MOBILE-APPLICATION-DEVELOPMENT',
  RESEARCH_AND_DEVELOPMENT = 'RESEARCH-AND-DEVELOPMENT',
  IT_STRATEGIC_CONSULTANCY = 'IT-STRATEGIC-CONSULTANCY',
  INCUBATION = 'INCUBATION',
  RESOURCE_AUGMENTATION = 'RESOURCE-AUGMENTATION',
}

export enum CONSULTATION_SERVICES {
  ENTERPRISE_SOFTWARE_SOLUTION = 'Enterprise Software Solutions',
  WEBSITE_DESIGN_AND_DEVELOPMENT = 'Website Design and Development',
  MOBILE_APPLICATION_DEVELOPMENT = 'Mobile Application Development',
  RESEARCH_AND_DEVELOPMENT = 'Research and Development',
  IT_STRATEGIC_CONSULTANCY = 'IT Strategic Consultancy',
  INCUBATION = 'Incubation',
  RESOURCE_AUGMENTATION = 'Resource Augmentation',
  OTHER = 'Other',
}

export enum CONSULTATION_PRODUCTS {
  CREDENT_EL = 'Identity and Access Management System',
  ARCHIV_EL = 'eDocument Management System',
  EL_LEARN = 'Learning Management System',
  FINANCI_EL = 'Business Banking Solution',
  INSUR_EL = 'Comprehensive Insurance Ecosystem',
  PROP_EL = 'Performance Management System',
  VISUA_EL = 'Video Based Customer Platform System',
  COLLECTA = 'Debt Recovery and Management System',
  DEBENT_EL = 'Debenture Management System',
}

export enum PRODUCT_PAGES {
  IDENTITY_ACCESS_MANAGEMENT = 'credentEL',
  DOCUMENT_MANAGEMENT_SYSTEM = 'archivEL',
  LEARNING_MANAGEMENT_SYSTEM = 'eLearn',
  BUSINESS_BANKING_SOLUTION = 'financiEL',
  COMPREHENSIVE_INSURANCE_ECOSYSTEM = 'insurEL',
  PERFORMANCE_MANAGEMENT_SYSTEM = 'propEL',
  VIDEO_BASED_CUSTOMER_PLATFORM_SYSTEM = 'visuaEL',
  DEBT_RECOVERY_MANAGEMENT_SYSTEM = 'collecta',
  DEBENTURE_MANAGEMENT_SYSTEM = 'debentEL',
}

export enum CONSULTATION_CONFIGURE_TYPE {
  INTERNAL = 'internal',
  EXTERNAL = 'external',
}
